<template>
  <el-button type="primary" size="mini" plain @click="pushView">
    View
  </el-button>
</template>

<script>
export default {
  props: {
    productSlug: String,
    variantId: String,
  },
  methods: {
    pushView() {
      window.open(`${ process.env.VUE_APP_APP_HOST }/store/${ this.productSlug }~${ this.variantId }`)
    }
  }
}
</script>
